import { Injectable } from "@angular/core";
import { Legierung, Product, ProductField, Shop, ProductsDto } from "cilor-db-api-shared";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Strings } from "../../shared/tools/Strings";
import { Variant } from "cilor-db-api-shared/dist/lib/product/Variant";

@Injectable({
  providedIn: "root"
})
export class ProductsService {
  public pageIndex: number;
  public pageSize: number;
  public sortPath: string;
  public filter: string;

  public data: ProductsDto | null;

  public loading: boolean;
  public error: string | null;

  public columnFilters: string[][];
  public columnFiltersDisplay: Array<(input: string) => string>;
  public columnFilterValues: string[];

  public constructor(
    public readonly httpClient: HttpClient,
  ) {
    this.pageIndex = 0;
    this.pageSize = 10;
    this.sortPath = ProductField.modellnummerIntern;
    this.filter = "";
    this.data = null;
    this.loading = false;
    this.error = null;

    this.columnFilters = [
      Object.values(Shop),
      Object.values(Legierung),
      Object.values(Variant),
    ];

    this.columnFiltersDisplay = [
      (input: string) => this.shopDisplay(input as Shop),
      (input: string) => this.legierungDisplay(input as Legierung),
      (input: string) => this.variantDisplay(input as Variant),
    ];

    this.columnFilterValues = [
      Shop.minora,
      Legierung.au585,
      Variant.ring,
    ];
  }

  public shopDisplay(shop: Shop): string {
    switch (shop) {
    case Shop.minora: return "Minora";
    case Shop.cilorB2B: return "Cilor B2B";
    case Shop.cilorB2C: return "Cilor B2C";
    case Shop.tw: return "Trauringwunder";
    case Shop.schmuckwunder: return "Schmuckwunder";
    }
  }

  public legierungDisplay(legierung: Legierung): string {
    switch (legierung) {
    case Legierung.ag925: return "AG925";
    case Legierung.au333: return "AU333";
    case Legierung.au375: return "AU375";
    case Legierung.au585: return "AU585";
    case Legierung.au750: return "AU750";
    case Legierung.pt600: return "PT600";
    case Legierung.pt950: return "PT950";
    case Legierung.pd585: return "PD585";
    case Legierung.pd950: return "PD950";
    }
  }

  public variantDisplay(variant: Variant): string {
    switch (variant) {
      case Variant.ringMitSteinen: return "mit Brillanten";
      case Variant.ringMitZirkonia: return "mit Zirkonia";
      case Variant.ring: return "ohne Steinbesatz";
    }
  }

  public async loadProducts(): Promise<void> {
    try {
      this.loading = true;
      this.error = null;
      const result = await this.httpClient.get<ProductsDto>("/api/products",
        {
          params: {
            flat: "false",
            page: this.pageIndex.toString(),
            pageSize: this.pageSize.toString(),
            sortPath: this.sortPath,
            sortDirection: "asc",
            filter: this.filter,
          }
        }
      ).toPromise();
      this.data = result;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      if (e instanceof HttpErrorResponse) {
        this.error = `Error: ${e.error?.message ?? Strings.unknownError}`;
      } else if (e instanceof Error) {
        this.error = e.message;
      } else {
        this.error = Strings.unknownError;
      }
    }
  }

  public async deleteProduct(product: Product): Promise<void> {
    try {
      this.loading = true;
      await this.httpClient.delete<ProductsDto>(`/api/products/${product[ProductField.id]}`).toPromise();
      await this.loadProducts();
    } catch (e) {
      alert(e.message);
      this.loading = false;
    }
  }
}
